import React, {useEffect, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {useParams} from "react-router-dom";
import FileViewer from "../../drive/fileViewer/fileViewer";
import UserInfo from "../../shared/userInfo/user-info";
import {Spinner, TitlePage} from "../../shared";
import functions from "../../../utils/functionsFirebase";
import useDownloadStore from "../../../store/downloadStore";
import {formatFileSize} from "../../../utils/utils";

function SharedFile() {

    const intl = useIntl();
    const {id} = useParams();
    const [file, setFile] = useState({loading: true});
    const {addFileToQueue} = useDownloadStore(state => state.actions);
    const [fileViewerHeight, setFileViewerHeight] = useState("400px");
    const viewerContainerRef = React.useRef(null);

    useEffect(() => {
        const getFileByShareUrl = functions.httpsCallable('getFileByShareUrl');
        getFileByShareUrl({shareUrl: id}).then(res => {
            setFile(res.data.file);
        }, error => {
            console.log(error);
        })
    }, [id])

    useEffect(() => {
        function updateFileViewerHeight() {
            if (viewerContainerRef.current) {
                const containerHeight = viewerContainerRef.current.clientHeight;
                setFileViewerHeight(containerHeight + "px");
            }
        }

        updateFileViewerHeight();
        window.addEventListener('resize', updateFileViewerHeight);
        return () => window.removeEventListener('resize', updateFileViewerHeight);
    }, []);

    return (
        <div className="container" style={{height: "99%"}}>
            <TitlePage title={file.fileName} icon="fa-solid fa-share-nodes" leftClass="col-12"/>
            {file?.uid &&
                <div className="mt-2 mb-3 d-flex flex-row justify-content-between align-items-center">
                    <UserInfo uid={file.uid}/>
                    <button title={intl.formatMessage({id: "file-viewer.download-file"})}
                            className="btn btn-outline-secondary btn-lg" style={{fontSize: "1rem"}}
                            onClick={() => addFileToQueue(file)}>
                        <FormattedMessage id="file-viewer.download-file"/>
                        <i className="fa-solid fa-download ms-3 fa-xl"></i>
                        <small className="d-block" style={{
                            fontSize: "0.75rem",
                        }}>
                            {formatFileSize(file.size)}
                        </small>
                    </button>
                </div>}
            <div ref={viewerContainerRef} style={{
                height: "calc(100% - 120px)",
                position: "relative",
            }}>
                {file.loading &&
                    <div className="d-flex flex-row justify-content-center">
                        <Spinner/>
                    </div>}
                {file?.fileName &&
                    <FileViewer file={file} maxHeightItems={fileViewerHeight} showInfo={false} infoTop={false}/>}
            </div>
        </div>
    )

}

export default SharedFile;
